import React, { useEffect, useState } from 'react';
import { FaUser, FaTools, FaCalendarAlt, FaMapMarkerAlt, FaClipboardList, FaFileAlt, FaUserTie, FaIndustry, FaCalendar, FaCode, FaTrashAlt } from 'react-icons/fa';
import ReportAssignments from './Components/ReportAssignments/ReportAssignments';
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorToast, SuccessToast } from '../../../../utils/toast';
import { get_schedule_by_id, handle_schedule_update, query_view_by_id } from '../../../../config/Worksite/scheduleApis';
import { FaProjectDiagram } from "react-icons/fa";
import { FaPersonDigging } from "react-icons/fa6";
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { MdMergeType } from "react-icons/md";
import { GrTechnology } from "react-icons/gr";
import './ScheduleDetails.css';
import ReportAddForm from '../Components/ReportAddForm/ReportAddForm';
import CustomModal from '../../../../Components/custom_components/CustomModal/CustomModal';
import ReportStatusChangeForm from '../Components/ReportAddForm/ReportStatusChangeForm';
import { addReport, changeReportStatus, reportCompletionByReportIds, reportReassign, schedule_accept_rejectByAdmin, updateScheduleEngineers, updateScheduleEquipments } from '../../../../config/ReportApis/scheduleReportApis';
import CustomConfirmModal from '../../../../Components/custom_components/CustomConfirmModal/CustomConfirmModal';
import { getScheduleProgressStyle, getStatusColors } from '../../../../utils/constants';
import CustomActionButtonWithTooltip from '../../../../Components/CustomActionButtonWithTooltip/CustomActionButtonWithTooltip';
import AddEngineerModal from '../Components/AddEngineerModal/AddEngineerModal';
import { Icons } from '../../../../utils/GlobalIcons';
import AddSchEquipmementModal from '../Components/AddSchEquipmementModal/AddSchEquipmementModal';
import { useSelector } from 'react-redux';
import { hasPrivilege } from '../../../../utils/privileges';
import TextSkeleton from '../../../../Components/Skeletons/TextSkeleton';
import CustomSkelton from '../../../../Components/Skeletons/CustomSkelton';
import InvoiceOverviewCard from '../Components/InvoiceOverview/InvoiceOverviewCard';
import { LuCalendarClock } from "react-icons/lu";
import { ReportDescription } from './Components/ReportDescription/ReportDescription';

const columnStyle = { display: 'flex', gap: '20px', marginBottom: '20px', padding: '10px', width: '100%' };
const renderSkeletonCard = () => (
    <div style={columnStyle}>
        <CustomSkelton
            variant="rounded"
            height={240}
            width={`100%`}
            animation="wave"
            style={{ borderRadius: '12px', marginRight: '20px' }}
        />
    </div>
);

const ScheduleDetails = () => {
    const Navigate = useNavigate()
    const privileges = useSelector((state) => state.privileges.privileges);

    const { scheduleId } = useParams(); // gets ND_scheduleID
    const [scheduleInfo, setScheduleInfo] = useState([]); //for schedule details
    const [scheduleReportData, setscheduleReportData] = useState([]); //for report details
    const [viewQueryModal, setViewQueryModal] = useState({});

    const [isLoading, setIsLoading] = useState(false); // Loader state

    const [reportModal, setReportModal] = useState({
        isOpen: false,
        scheduleId: null,
        values: null,
        reportId: null,
    });

    const [reportStatusModal, setReportStatusModal] = useState({
        isOpen: false,
        scheduleId: null,
        latestStatusId: null,
        reportId: null,
        type: ''
    });

    const [markReportComplete, setMarkReportComplete] = useState({
        isOpen: false,
        ScheduleID: '',
        scheduleReport: [], // array of report IDs
        report_is_complete: 1 // fixed value
    });

    //schedule accept/reject for fse via admin
    const [actionModal, setActionModal] = useState({
        isOpen: false,
        type: null, // 1 for accept, 2 for reject 
        id: null,
        info: null,
    });


    const [modalState, setModalState] = useState({
        isOpen: false,
        type: null, // 'engineer' or 'equipment'
        id: null,
    })

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [refresh, setRefresh] = useState(false);

    // Define the required permission actions
    const PERMISSION_ACTIONS = {
        view: 4,
        edit: 5,
        history: 6,
        add: 3,
        addReport: 9,
        reAssign: 10,
        changeStatus: 11,
        ViewReport: 12,
        changeProcess: 13,
        invoiceOverView: 16
    };

    // Map permissions to boolean values based on privileges
    const userPermissions = {
        view: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.view),
        edit: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.edit),
        ViewReport: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.ViewReport),
        addReport: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.addReport),
        reAssign: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.reAssign),
        changeStatus: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.changeStatus),
        changeProcess: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.changeProcess),
        invoiceOverView: hasPrivilege(privileges, "Work site", 3, PERMISSION_ACTIONS.invoiceOverView),

    };
    // Fetch details of a query
    const fetchQueryDetails = async (scheduleID) => {
        try {
            const response = await query_view_by_id({ scheduleID });
            if (response?.data?.status === "success") {
                const data = response?.data?.data || {};
                setViewQueryModal(data)
            } else {
                ErrorToast(response?.message);
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        }
    };

    useEffect(() => {
        if (scheduleId) {
            fetchScheduleDetails(scheduleId)
            //  fetchQueryDetails(scheduleId)
        }
    }, [scheduleId, refresh])

    useEffect(() => {
        const isShowQueryDetails = scheduleInfo?.Is_query_sended && scheduleInfo?.Is_query_assigned_by
        if (scheduleId && isShowQueryDetails) { //ONLY SHOW THE QUERY DETAILS ONLY  THE CORRESPONDING USERES
            fetchQueryDetails(scheduleId)
        }

    }, [scheduleInfo])

    // Fetch details of a specific schedule item
    const fetchScheduleDetails = async (scheduleID) => {
        try {
            setIsLoading(true)
            // const response = await get_schedule_reporting_view_by_id({ scheduleID });
            const response = await get_schedule_by_id({ scheduleID });
            if (response?.status === "success") {
                const scheduleData = response?.data;
                const reportData = response?.reports;
                setScheduleInfo(scheduleData)
                setscheduleReportData(reportData)
            } else {
                setscheduleReportData([])
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            setscheduleReportData([])
            ErrorToast('Something went wrong!');
        } finally {
            setIsLoading(false);
        }
    };


    // detail item 
    const DetailItem = ({ icon, label, value, wide = false }) => (
        <div className={`detail-item ${wide ? 'wide' : ''}`}>
            <span className='schedule-detail-icon'>{icon}</span>
            <label>{label}:</label>
            <span>{value}</span>
        </div>
    );

    const DetailList = ({ icon, label, items = [] }) => (
        <div className="detail-item">
            <span className="schedule-detail-icon">{icon}</span>
            <label>{label}:</label>
            <ul className={`detail-list ${items?.length > 5 ? 'multi-column-list' : ''}`}>
                {items?.length ? items.map((item, index) => (
                    <li key={index}>{item}</li>
                )) : <li>—</li>}
            </ul>
        </div>
    );

    //for schedule Current progress
    const scheduleCurrentProgress = scheduleInfo?.Is_completed || '-'

    const isScheduleCanceled = scheduleInfo?.is_cancel === 1 ? true : false //1 MEANS CANCELED

    const isScheduleStarted = scheduleInfo?.Shedule_process_status !== 0;  //0 MEANS NOT STARTED

    const isScheduleActive = scheduleInfo?.SD_Status === 1 ? true : false //1 ACTIVE CANCELED

    const scheduleStatusText = isScheduleActive ? `Active` : `Inactive`

    const IsUrgentSchedule = scheduleInfo?.is_urgent == 1 //1 MEANS URGENT


    const handlePrev = () => {
        Navigate('/worksites/schedule/overview', { replace: true })
    }

    // FOR REPORT ADD/EDIT SECTION
    const handleOpenReportModal = (values = null, scheduleId = null, reportId = null) => {
        setReportModal({
            isOpen: true,
            scheduleId,
            values,
            reportId
        });
    };

    const handleCloseReportModal = () => {
        setReportModal({
            isOpen: false,
            scheduleId: null,
            values: null,
            reportId: null,
        });
    };

    // FOR ADD A REPORT AGAINT A SCHEDULE
    const handleSaveReport = async (formData, id) => {
        const params = {
            ...formData,
            scheduleID: id,
        }

        try {
            setIsButtonDisabled(true);
            const response = await addReport(params);

            if (response?.status === "success") {
                setRefresh(prev => !prev); // Refresh table
                handleCloseReportModal();
                SuccessToast(response?.message);
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        } finally {
            setIsButtonDisabled(false);
        }
    };

    // OPEN Report Status Change Modal
    const handleOpenReportStatusModal = (scheduleId = null, latestStatusId = null, reportId = null, type = '') => {
        setReportStatusModal({
            isOpen: true,
            scheduleId,
            latestStatusId,
            reportId,
            type
        });
    };
    // CLOSE Report Status Change Modal
    const handleCloseReportStatusModal = () => {
        setReportStatusModal({
            isOpen: false,
            scheduleId: null,
            latestStatusId: null,
            reportId: null,
            type: ''
        });
    };

    // SCHEUDLE ACCEPT/REJECT FOR FSE VIA ADMIN
    const openActionModal = (id, type, info) => {
        setActionModal({
            isOpen: true,
            id,
            type,
            info
        });
    };

    const closeActionModal = () => {
        setActionModal({ isOpen: false, type: null, id: null, info: null });
    };

    // SAVE Report Status Change
    const handleSaveReportStatusChange = async (formData) => {

        try {
            setIsButtonDisabled(true);
            const response = await changeReportStatus(formData);

            if (response?.status === "success") {
                setRefresh(prev => !prev); // Refresh table
                handleCloseReportStatusModal();
                SuccessToast(response?.message);
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        } finally {
            setIsButtonDisabled(false);
        }
    };
    // FOR REPORT REASSIGN BY ADMIN/SUPERVISOR
    const handleReportReassign = async (formData) => {

        try {
            setIsButtonDisabled(true);
            const response = await reportReassign(formData);

            if (response?.status === "success") {
                setRefresh(prev => !prev); // Refresh table
                handleCloseReportStatusModal();
                SuccessToast(response?.message);
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        } finally {
            setIsButtonDisabled(false);
        }
    };

    const handleMarkCompleteModal = (isOpen, ScheduleID = '', scheduleReport = []) => {
        if (!isOpen) {
            // Reset everything on close
            setMarkReportComplete({
                isOpen: false,
                ScheduleID: '',
                scheduleReport: [],
                report_is_complete: 1
            });
        } else {
            // Open with given values
            setMarkReportComplete({
                isOpen: true,
                ScheduleID,
                scheduleReport,
                report_is_complete: 1
            });
        }
    };

    // FOR MARK REPORT COMPLETION
    const handleMarkAsComplete = async (data, isCompleteDirectly) => {
        let payload;

        if (isCompleteDirectly) {
            // When called directly (ex: from process modal)
            payload = {
                ScheduleID: data.scheduleId,
                scheduleReport: [data.reportId],
                is_submitted: 1,
                report_is_complete: 1,
            };
        } else {
            // Default case
            payload = {
                ScheduleID: data.ScheduleID,
                scheduleReport: data.scheduleReport,
                report_is_complete: 1,
                is_submitted: 0
            };
        }
        try {
            setIsButtonDisabled(true);
            const response = await reportCompletionByReportIds(payload);
            if (response?.status === "success") {
                setRefresh(prev => !prev); // Refresh table
                handleMarkCompleteModal(false);
                handleCloseReportStatusModal() //FOR CLOSE THE PROCESS || RE-ASSIGN MODAL
                SuccessToast(response?.message);
            } else {
                // ErrorToast(response?.message, true, response?.data);
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        } finally {
            setIsButtonDisabled(false);
        }
    };

    // FOR GET THE LATEST SCHEDULE PROGRESS COLOR VIA ID
    // const actionColors = getActionColors(scheduleInfo.Shedule_process_status);
    const progressStyle = getScheduleProgressStyle(scheduleInfo.Shedule_process_status);

    const handleScheduleCompletion = async (data) => {
        // const data = {
        //     ScheduleID: scheduleId,
        //     Shedule_Status: statusId, // Default = 2 → Completed
        // };

        try {
            const response = await handle_schedule_update(data);

            if (response?.status === "success") {
                setRefresh(prev => !prev); // Refresh table
                SuccessToast(response?.message || "Schedule completed successfully");
            } else {
                ErrorToast(response?.message || "Failed to update schedule status");
            }
        } catch (error) {
            console.error("Error updating schedule:", error);
            ErrorToast("Something went wrong while updating schedule");
        } finally {
            setIsButtonDisabled(false);
            closeModal?.();
            closeActionModal?.();
        }
    };

    // REPORT
    const handleScheduleAction = async ({ scheduleId, id, type }) => {

        if (type == 1 || type == 2) { // (1 == acept 2 - reject)
            const params = {
                scheduleId,
                employeeID: [id],
                is_accept: type
            }
            try {

                setIsButtonDisabled(true);
                const response = await schedule_accept_rejectByAdmin(params);

                if (response?.status === "success") {
                    closeActionModal();
                    setRefresh(prev => !prev); // Refresh table
                    SuccessToast(response?.message);
                } else {
                    ErrorToast(response?.message || 'Something went wrong!');
                }
            } catch (error) {
                ErrorToast('Something went wrong!');
            } finally {
                setIsButtonDisabled(false);
            }
        } else if (type === 3) { // (type 3 means remove fse from schedule)
            const params = {
                engineerIDs: [id] || [],
                scheduleID: scheduleId,
            }

            handleAddOrUpdateEngineers(params, `Remove`)
        } else if (type === 4) { // (type 3 means remove equipment from schedule)
            const params = {
                equipmentIDs: [id] || [],
                scheduleID: scheduleId,
            }

            handleAddOrUpdateEquipments(params, `Remove`)
        } else if (type === 5) {
            // Type 5 → Complete Schedule
            const params = {
                ScheduleID: scheduleId,
                employeeID: id,
                Shedule_Status: 2, // 2 means completed
            };
            handleScheduleCompletion(params);
        }
    };

    //-------------------------------------- FOR ENGINEERS ADD TO SCHEDULE START

    // FOR ADD/REMOVE ENGINEERS FROM SCHEDULE
    const handleAddOrUpdateEngineers = async (formValues, purpose) => {
        const params = {
            engineerID: formValues?.engineerIDs || [],
            scheduleID: scheduleInfo.SD_id,
            purpose
        }

        try {

            setIsButtonDisabled(true);
            const response = await updateScheduleEngineers(params);

            if (response?.status === "success") {
                closeActionModal();
                closeModal()
                setRefresh(prev => !prev); // Refresh table
                SuccessToast(response?.message);
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        } finally {
            setIsButtonDisabled(false);
        }
    };
    //-------------------------------FOR ENGINEERS ADD TO SCHEDULE END


    // FOR ADD/REMOVE EQUIPMENTS FROM SCHEDULE
    const handleAddOrUpdateEquipments = async (formValues, purpose) => {
        const params = {
            equipmentIDs: formValues?.equipmentIDs || [],
            scheduleID: scheduleInfo.SD_id,
            purpose
        }

        try {

            setIsButtonDisabled(true);
            const response = await updateScheduleEquipments(params);

            if (response?.status === "success") {
                setRefresh(prev => !prev); // Refresh table
                closeModal()
                closeActionModal()
                SuccessToast(response?.message);
            } else {
                ErrorToast(response?.message || 'Something went wrong!');
            }
        } catch (error) {
            ErrorToast('Something went wrong!');
        } finally {
            setIsButtonDisabled(false);
        }
    };

    //-------------------------------------- FOR ENGINEERS/EQUIPMENTS ADD TO SCHEDULE START
    const openModal = (type, id = null) => {
        setModalState({
            isOpen: true,
            type,
            id,
        });
    };

    const closeModal = () => {
        setModalState({
            isOpen: false,
            type: null,
            id: null,
        });
    };
    //-------------------------------------- FOR ENGINEERS/EQUIPMENTS ADD TO SCHEDULE END


    return (

        <>
            <div className="schedule-details-container">
                {/* Header */}
                <div className="schedule-details-container-top">
                    <div className="schedule-details-header-left">
                        {isLoading ? (
                            <div className='schedule-details-title-skelton-container'>
                                <TextSkeleton width="100%" fontSize="3rem" />
                            </div>
                        ) : (
                            <span className={`schedule-details-title ${isScheduleCanceled ? "canceled" : ""}`}>
                                {IsUrgentSchedule && (
                                    <span className="schedule-urgent-badge">
                                        <Icons.Warning />
                                    </span>
                                )}
                                <span style={{ marginLeft: IsUrgentSchedule ? '8px' : '0' }}>
                                    Schedule Overview ({scheduleInfo?.SD_ScheduleCode})
                                </span>
                            </span>
                        )}

                        {!isLoading && isScheduleCanceled && (
                            <span className="schedule-cancelled-badge">Cancelled</span>
                        )}
                        {!isLoading && !isScheduleCanceled && <span style={progressStyle}>{scheduleCurrentProgress}</span>}
                    </div>

                    <ActionButton onClick={handlePrev} label="Back" btnType="primary" />
                </div>

                {isLoading ? (
                    <div className="schedule-details-loader-container">
                        {renderSkeletonCard()} {renderSkeletonCard()} {renderSkeletonCard()}
                    </div>
                ) : (
                    <>
                        {/* Column-wise layout */}
                        <div className="details-column-wrapper">
                            {/* Schedule Section */}
                            <div className="details-section">
                                <h3 className="section-title">Schedule</h3>
                                <div className="details-grid">
                                    <DetailItem icon={<FaUserTie />} label="Created"
                                        value={scheduleInfo?.schedule_createdBy || `N/A`} wide />
                                    <DetailItem icon={<FaCalendarAlt />} label="Survey Period"
                                        value={`${scheduleInfo?.SD_Survey_from_date || `N/A`} to ${scheduleInfo?.SD_Survey_end_date || `N/A`}`} wide />
                                    <DetailItem icon={<GrTechnology />} label="Technology"
                                        value={scheduleInfo?.technology?.TechnologiesTypeName || `N/A`} wide />
                                    <DetailItem icon={<LuCalendarClock />} label="Frequency"
                                        value={scheduleInfo?.Frequency_name || `N/A`} wide />

                                    {!isScheduleCanceled &&
                                        <div className="detail-item">
                                            <FaClipboardList className="schedule-detail-icon" />
                                            <label>Status:</label>
                                            <span className={`sch-status-badge`} style={getStatusColors(scheduleInfo?.SD_Status)} >{scheduleStatusText}</span>
                                        </div>
                                    }
                                </div>
                                <ReportDescription description={scheduleInfo?.SD_ScheduleDescription || `N/A`} />

                            </div>

                            {/* Worksite Section */}
                            <div className="details-section">
                                <h3 className="section-title">Worksite</h3>
                                <div className="details-grid">
                                    <DetailItem icon={<FaPersonDigging />} label="Worksite"
                                        value={`${scheduleInfo?.worksite?.WD_WorksiteName || `N/A`}`} />
                                    <DetailItem icon={<FaCode />} label="Site Code"
                                        value={scheduleInfo?.worksite?.WD_SiteCode || `N/A`} wide />
                                    <DetailItem icon={<FaMapMarkerAlt />} label="Location"
                                        value={scheduleInfo?.worksite?.WD_Location || `N/A`} wide />
                                    <DetailList
                                        icon={<FaUserTie />}
                                        label="Supervisors"
                                        items={scheduleInfo?.assigned_supervisor?.map((e) =>
                                            `${e?.name || `N/A`}`
                                        )}
                                    />
                                </div>
                                <ReportDescription description={scheduleInfo?.worksite?.WD_Description || `N/A`} />

                            </div>

                            {/* Project Section */}
                            <div className="details-section">
                                <h3 className="section-title">Project</h3>

                                <div className="details-grid">
                                    <DetailItem icon={<FaProjectDiagram />} label="Project"
                                        value={scheduleInfo?.projectName || `N/A`} />
                                    <DetailItem icon={<MdMergeType />} label="Type"
                                        value={scheduleInfo?.projecttype === 1 ? 'One Time' : 'Contract'} wide />

                                    <DetailItem icon={<FaIndustry />} label="Client"
                                        value={scheduleInfo?.worksite?.project?.PD_ClientName || `N/A`} />
                                    <DetailItem icon={<FaCalendar />} label="Duration"
                                        value={`${scheduleInfo?.worksite?.project?.PD_StartDate || `N/A`} to ${scheduleInfo?.worksite?.project?.PD_EndDate || `N/A`}`} wide />
                                </div>
                                <ReportDescription description={scheduleInfo?.worksite?.project?.PD_Description || `N/A`} />

                            </div>

                        </div>
                    </>
                )}


                {isLoading ? (
                    <div className="schedule-details-loader-container">
                        {renderSkeletonCard()} {renderSkeletonCard()}
                    </div>
                ) : (
                    <>
                        {/* Column-wise layout */}
                        <div className="details-column-wrapper">
                            {/* Schedule accepted */}
                            <div className="details-section">
                                <div className="engineer-header">
                                    <div className="engineer-title-center">
                                        <span>Engineers</span>
                                    </div>
                                    {/* show button have edit privilege and the schedule is not competed */}
                                    {!isScheduleCanceled && userPermissions.edit && scheduleInfo?.SD_is_completed !== 2 && isScheduleActive && <div className="engineer-button-right">
                                        <CustomActionButtonWithTooltip
                                            title="Add Engineer"
                                            placement="top"
                                        >
                                            <Icons.Add className="schedule-detail-icon"
                                                onClick={() => openModal(`Engineer`, scheduleId)}
                                            />
                                        </CustomActionButtonWithTooltip>
                                    </div>}

                                </div>
                                <div className="details-grid">
                                    <div className={`details-grid-scrollable ${scheduleInfo?.assigned_users?.length > 5 ? 'limited-scroll' : ''}`}>
                                        {Array.isArray(scheduleInfo?.assigned_users) && scheduleInfo.assigned_users.length > 0 ? (
                                            scheduleInfo.assigned_users.map((e, index) => {
                                                const status = e?.is_accept; // 1: Accepted, 2: Rejected, 0 or null: Assigned
                                                const isMarkedComplete = e?.CompletedStatus; // 0: Not Started, 1: In Progress, 2: Completed

                                                let statusLabel = 'Assigned';
                                                let statusClass = 'schedule-assigned';

                                                if (isMarkedComplete === 2) {
                                                    statusLabel = 'Completed';
                                                    statusClass = 'schedule-completed';
                                                } else if (isMarkedComplete === 1) {
                                                    statusLabel = 'In Progress';
                                                    statusClass = 'schedule-inprogress';
                                                } else if (status === 1) {
                                                    statusLabel = 'Accepted';
                                                    statusClass = 'schedule-accepted';
                                                } else if (status === 2) {
                                                    statusLabel = 'Rejected';
                                                    statusClass = 'schedule-rejected';
                                                } else if (e?.onHold) {
                                                    statusLabel = 'On Hold';
                                                    statusClass = 'schedule-onhold';
                                                }
                                                // console.log("scheduleInfo", scheduleInfo);

                                                const canAccept = userPermissions.edit && status === 0 && isMarkedComplete === 0 && scheduleInfo?.is_mobilize === 1 && scheduleInfo?.Shedule_process_status !== 2 && !isScheduleCanceled; // isScheduleCanceled  true means canceled 
                                                const canReject = userPermissions.edit && status === 0 && scheduleInfo?.is_mobilize === 1 && scheduleInfo?.Shedule_process_status !== 2 && !isScheduleCanceled;
                                                const canRemove = userPermissions.edit && !isScheduleCanceled && (
                                                    (status === 1 && isMarkedComplete === 0) ||
                                                    (status === 0 && isMarkedComplete === 0)
                                                );
                                                const canComplete = userPermissions.edit && (scheduleInfo?.Shedule_process_status == 1 || scheduleInfo?.Shedule_process_status == 3 || scheduleInfo?.Shedule_process_status == 4) && !isScheduleCanceled && isMarkedComplete == 1; //1: In Progress

                                                // console.log("canAccept,canReject,isMarkedComplete,statusLabel", statusLabel, canAccept, canReject, isMarkedComplete);
                                                return (
                                                    <div key={index} className={`details-grid details-scroll-wrapper schedule-card ${statusClass}`}>
                                                        <div className="schedule-header">
                                                            <DetailList
                                                                icon={<FaUser />}
                                                                label=""
                                                                items={[
                                                                    e?.name
                                                                        ? `${e.name}${e?.designation ? ` (${e.designation})` : ''}`
                                                                        : `N/A`
                                                                ]}
                                                            />

                                                            <span className="schedule-badge">{statusLabel}</span>
                                                            <div className="report-action-buttons-container">
                                                                {canAccept && (
                                                                    <CustomActionButtonWithTooltip
                                                                        title="Accept"
                                                                        placement="top"
                                                                        onClick={() => openActionModal(e.id, 1, e)}
                                                                    >
                                                                        <Icons.Check className="report-action-icon report-action-icon-accept" />
                                                                    </CustomActionButtonWithTooltip>
                                                                )}

                                                                {canReject && (
                                                                    <CustomActionButtonWithTooltip
                                                                        title="Reject"
                                                                        placement="top"
                                                                        onClick={() => openActionModal(e.id, 2, e)}
                                                                    >
                                                                        <Icons.Close className="report-action-icon report-action-icon-reject" />
                                                                    </CustomActionButtonWithTooltip>
                                                                )}

                                                                {canRemove && (
                                                                    <CustomActionButtonWithTooltip
                                                                        title="Remove"
                                                                        placement="top"
                                                                        onClick={() => openActionModal(e.id, 3, e)}
                                                                    >
                                                                        <Icons.Remove className="report-action-icon report-action-icon-remove" />
                                                                    </CustomActionButtonWithTooltip>
                                                                )}

                                                                {canComplete && (
                                                                    <CustomActionButtonWithTooltip
                                                                        title="Complete"
                                                                        placement="top"
                                                                        onClick={() => openActionModal(e.id, 5, e)}
                                                                    >
                                                                        <Icons.Complete className="report-action-icon report-action-icon-complete" />
                                                                    </CustomActionButtonWithTooltip>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <DetailItem
                                                            icon={<FaCalendarAlt />}
                                                            label=""
                                                            value={e?.acceptDate || `N/A`}
                                                        />
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <p className="no-data-message">No assigned engineers available.</p>
                                        )}
                                    </div>
                                </div>
                            </div>


                            {/*  accpeted Equipment*/}
                            <div className="details-section">

                                <div className="engineer-header">
                                    <div className="engineer-title-center">
                                        <span>Equipments</span>
                                    </div>
                                    {!isScheduleCanceled && userPermissions.edit && scheduleInfo?.SD_is_completed !== 2 && isScheduleActive && <div className="engineer-button-right">
                                        <CustomActionButtonWithTooltip
                                            title="Add Equipments"
                                            placement="top"
                                        >
                                            <Icons.Add className="schedule-detail-icon"
                                                onClick={() => openModal(`Equipments`, scheduleId)}
                                            />
                                        </CustomActionButtonWithTooltip>
                                    </div>}

                                </div>

                                <div className="details-grid">
                                    {Array.isArray(scheduleInfo?.schedule_equipment) && scheduleInfo.schedule_equipment.length > 0 ? (
                                        scheduleInfo?.schedule_equipment?.map((e, index) => (
                                            <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                <DetailList
                                                    icon={<FaTools />}
                                                    label=""
                                                    items={[`${e?.equipments?.EquipmentName || `N/A`} (${e?.equipments?.EquipmentserialNo || `N/A`})`]}
                                                />
                                                {!isScheduleCanceled && userPermissions.edit && scheduleInfo?.SD_is_completed !== 2 &&
                                                    <CustomActionButtonWithTooltip
                                                        title="Remove"
                                                        placement="top"
                                                        onClick={() => openActionModal(e.SEM_EquipmentID, 4, e)}
                                                    >
                                                        <FaTrashAlt className="report-action-icon report-action-icon-remove" />
                                                    </CustomActionButtonWithTooltip>}
                                            </div>
                                        ))
                                    ) : (
                                        <p className='no-data-message'>No equipment data available.</p>
                                    )}
                                </div>
                            </div>

                            {/* INVOICE OVER VIEW */}
                            {userPermissions?.invoiceOverView && scheduleInfo?.invoicesDetails?.length > 0 &&
                                (
                                    <div className="details-section">

                                        <div className="engineer-header">
                                            <div className="engineer-title-center">
                                                <span>Invoice</span>
                                            </div>
                                        </div>

                                        <div className="details-grid">
                                            <InvoiceOverviewCard invoices={scheduleInfo?.invoicesDetails} />
                                        </div>

                                    </div>
                                )}


                            {/* QUERY INFO */}
                            {viewQueryModal && Object.keys(viewQueryModal).length > 0 && (
                                <div className="details-section">
                                    <h3 className="section-title">Query</h3>
                                    <div className="details-grid">
                                        <DetailItem
                                            icon={<FaPersonDigging />}
                                            label="Sent By"
                                            value={viewQueryModal?.submitted_by || `N/A`}
                                        />
                                        <DetailItem
                                            icon={<Icons.Workforce />}
                                            label="Sent To"
                                            value={viewQueryModal?.send_to || `N/A`}
                                        />

                                        {/* <DetailItem icon={<FaFileAlt />} label="Reply"
                                            value={viewQueryModal?.reply_text || `N/A`} wide /> */}
                                    </div>


                                    {/* <DetailItem icon={<FaFileAlt />} label="Query"
                                            value={viewQueryModal?.query_text || `N/A`} wide /> */}
                                    <ReportDescription title={`Query`} description={viewQueryModal?.query_text || `N/A`} />
                                    <DetailItem
                                        icon={<FaCalendarAlt />}
                                        label="Submission Date"
                                        value={viewQueryModal?.submitted_on || `N/A`}
                                        wide
                                    />

                                    <ReportDescription title={"Reply"} description={viewQueryModal?.reply_text || `N/A`} />
                                    <DetailItem
                                        icon={<FaCalendarAlt />}
                                        label="Reply Date"
                                        value={viewQueryModal?.replied_on || `N/A`}
                                        wide
                                    />
                                </div>
                            )}

                        </div>
                    </>
                )}

                {/* Report Section */}
                <ReportAssignments

                    reportsData={scheduleReportData}
                    handleOpenReportModal={handleOpenReportModal}
                    scheduleInfo={scheduleInfo}
                    scheduleId={scheduleInfo.SD_id}

                    handleOpenReportStatusModal={handleOpenReportStatusModal}
                    handleMarkCompleteModal={handleMarkCompleteModal}


                    isViewReport={userPermissions.ViewReport}
                    isAddReport={!isScheduleCanceled && userPermissions.addReport && isScheduleStarted && isScheduleActive && !scheduleInfo.sentFinance} //sentFinance TRUE MEANS FORWRED TO FINANCE

                    isReAssignReport={userPermissions.reAssign && !scheduleInfo.sentFinance}
                    isChangeReportStatus={userPermissions.changeStatus && !scheduleInfo.sentFinance}
                    isChangeReportProcess={userPermissions.changeProcess && !scheduleInfo.sentFinance}

                    isLoading={isLoading}
                    isScheduleCanceled={isScheduleCanceled}
                />
            </div>

            {/* REPORT COMPLETETION MODAL */}
            {markReportComplete.isOpen && <CustomConfirmModal
                custom_text={`Mark report as completed. Do you want to proceed?`}
                open_modal={markReportComplete.isOpen}
                close_modal={() => handleMarkCompleteModal(false)}
                confirm_function={() => handleMarkAsComplete(markReportComplete)}
                isButtonDisabled={isButtonDisabled}
            />}

            {/* REPORT STAUTUS CHNAGE MODAL */}
            {reportStatusModal?.isOpen && (
                <CustomModal
                    open={reportStatusModal?.isOpen}
                    handleClose={handleCloseReportStatusModal}
                    title={reportStatusModal?.type === 'reassign' ? `Re-Assign` : "Process"}
                    body={
                        <ReportStatusChangeForm
                            handleSave={reportStatusModal?.type === 'reassign' ? handleReportReassign : handleSaveReportStatusChange}
                            isButtonDisabled={isButtonDisabled}
                            scheduleId={reportStatusModal?.scheduleId}
                            reportId={reportStatusModal?.reportId}
                            isDisabled={false}
                            formType={reportStatusModal?.type}
                            defaultValues={scheduleInfo}
                            confirm_function={() => handleMarkAsComplete(reportStatusModal, true)}
                        />
                    }
                    //   height="100%"
                    maxWidth="1000px"
                />
            )}


            {/* REPORT FORM MODAL */}
            {reportModal?.isOpen && <CustomModal
                open={reportModal?.isOpen}
                handleClose={handleCloseReportModal}
                title={"Add Report"}
                body={
                    <ReportAddForm
                        handleSave={handleSaveReport}
                        isButtonDisabled={isButtonDisabled}
                        scheduleId={scheduleId}
                        isDisabled={false}
                        defaultValues={scheduleInfo}

                    />
                }
                maxWidth="800px"
            />}

            {/* FOR ENGINEERS ACCEPTE/REJECT MODAL */}
            {actionModal?.isOpen && (
                <CustomConfirmModal
                    custom_text={
                        actionModal.type === 1
                            ? 'Do you want to accept this schedule?'
                            : actionModal.type === 2 ? 'Do you want to reject this schedule?'
                                : actionModal.type === 3 ? `Do you want to remove ${actionModal?.info?.name} engineer?`
                                    : actionModal.type === 5 ?
                                        `Do you want to Complete this schedule?`
                                        : `Do you want to remove this Equipment?`
                    }
                    open_modal={actionModal.isOpen}
                    close_modal={closeActionModal}
                    confirm_function={() => {
                        handleScheduleAction({
                            scheduleId: scheduleInfo?.SD_id,
                            id: actionModal.id,
                            type: actionModal.type,
                        });

                    }}
                />
            )}
            {/* EQUIPMENT/ENGINEERS ADD TO A PARTICULAR SCHEDULE */}
            {modalState?.isOpen && <CustomModal
                open={modalState?.isOpen}
                handleClose={closeModal}
                title_other=""
                title={modalState?.isOpen ? modalState?.type?.toLowerCase() === 'engineer' ? "Add Engineers" : "Add Equipments" : ''}
                body={
                    modalState?.type?.toLowerCase() === 'engineer' ? (
                        <AddEngineerModal
                            handleSave={handleAddOrUpdateEngineers}
                            isButtonDisabled={isButtonDisabled}
                            defaultValues={scheduleInfo}
                            scheduleID={scheduleInfo?.SD_id}
                            IsUrgentSchedule={IsUrgentSchedule}
                        />
                    ) : (
                        <AddSchEquipmementModal
                            handleSave={handleAddOrUpdateEquipments}
                            isButtonDisabled={isButtonDisabled}
                            scheduleID={scheduleInfo?.SD_id}
                            scheduleInfo={scheduleInfo}
                            IsUrgentSchedule={IsUrgentSchedule}
                        />
                    )
                }
                height="50%"
                maxWidth="800px"
            />}

        </>

    );
};

export default ScheduleDetails;
